import React, {FunctionComponent} from 'react';
import styles from './loader.module.scss'
import {ReactComponent as LoadingIcon} from '../../../assets/images/loading.svg';

const LoaderComponent: FunctionComponent = () => {

    return <LoadingIcon className={styles.loadingIcon}/>
}
export default LoaderComponent;
